import { XIcon } from 'lucide-react';
import { Activity } from 'react';

import { Typography } from '@crossnokaye/ux-common';
import {
  Header,
  HeaderIcon,
  HeaderRightActions,
  HeaderTitle,
  HeaderTitleGroup,
} from '@crossnokaye/ux-common/ckds';

import { Badge } from '@/ux-common/components/badge/badge';
import { Button } from '@/ux-common/components/button/button';
import { cn } from '@/ux-common/lib/utils';

interface EquipmentBulkEditHeaderProps {
  deviceCount: number;
  isPushOutOpen: boolean;
  onClose: () => void;
  title: string;
}

export const EquipmentBulkEditHeader = ({
  deviceCount,
  isPushOutOpen,
  onClose,
  title,
}: EquipmentBulkEditHeaderProps) => {
  return (
    <Header align="center" className="min-h-[3rem] px-2 py-0">
      <HeaderIcon>
        <div className="flex h-full items-center">
          {/* TODO: Update component variant or use new badge component based on PM feedback */}
          <Badge className={cn('badge badge-default badge-pill')}>{deviceCount}</Badge>
        </div>
      </HeaderIcon>
      <HeaderTitleGroup>
        <HeaderTitle>
          <div className="flex h-full items-center">
            <Typography variant="body" className="text-primary uppercase leading-none">
              {title}
            </Typography>
          </div>
        </HeaderTitle>
      </HeaderTitleGroup>
      <Activity mode={isPushOutOpen ? 'hidden' : 'visible'}>
        <div className="flex h-full items-center">
          <HeaderRightActions>
            <Button
              className="btn btn-tier2 btn-md btn-circle"
              onClick={onClose}
              aria-label="Close"
            >
              <XIcon className="btn-icon" aria-hidden="true" />
            </Button>
          </HeaderRightActions>
        </div>
      </Activity>
    </Header>
  );
};
